import { useEffect, useState, useRef } from "react";
import useFsService from "../../../../services/fsService";
import { useParams } from "react-router-dom";
 

const useRecsBasket = (initialPrices = {}, initialPvs = {}, currencyCode = 'USD') => {
  const { getBasket, putInBasket, clearError } = useFsService();
  const [cart, setCart] = useState({});
  const [basketTotal, setBasketTotal] = useState(0);
  const [productPrices, setProductPrices] = useState(initialPrices);
  const [productPvs, setProductPvs] = useState(initialPvs);
  const [loadingProducts, setLoadingProducts] = useState({});
  const [errorProducts, setErrorProducts] = useState({});

  const { id } = useParams();

  useEffect(() => {
    setProductPrices(initialPrices);
    setProductPvs(initialPvs);
  }, [initialPrices, initialPvs]);

  useEffect(() => {
    const fetchBasket = async () => {
      clearError();
      try {
        const basketResponse = await getBasket(id);
        if (basketResponse.data.result) {
          const newCart = {};
          const products = basketResponse.data.data.products;

          products.forEach((product) => {
            newCart[product.code] = product.count;
          });

          setCart(newCart);

          const totalItems = Object.values(newCart).reduce((sum, count) => sum + count, 0);
          setBasketTotal(totalItems);
        }
      } catch (e) {
        console.error(e);
      }
    };

    fetchBasket();
  }, [id, initialPrices, initialPvs]);

  // ИСПРАВЛЕННАЯ ЛОГИКА - используем прямые значения вместо парсинга DOM
  const basketSum = Object.entries(cart).reduce((acc, [code, count]) => {
    const price = productPrices[code] || 0;  // ← Используем прямое значение
    console.log(`[Basket][sum] code=${code} count=${count} unitPrice=${price} lineTotal=${count * price}`);
    return acc + count * price;
  }, 0);

  const basketPvSum = Object.entries(cart).reduce((acc, [code, count]) => {
    const pv = productPvs[code] || 0;  // ← Используем прямое значение
    return acc + count * pv;
  }, 0);

  const handleAddToCart = async (productCode) => {
    if (productPrices[productCode] == null && initialPrices[productCode] != null) {
      setProductPrices((prev) => ({
        ...prev,
        [productCode]: Number(initialPrices[productCode]) || 0,
      }));
    }
    if (productPvs[productCode] == null && initialPvs[productCode] != null) {
      setProductPvs((prev) => ({
        ...prev,
        [productCode]: Number(initialPvs[productCode]) || 0,
      }));
    }
    const newCount = (cart[productCode] || 0) + 1;

    setLoadingProducts((prev) => ({ ...prev, [productCode]: true }));
    setErrorProducts((prev) => ({ ...prev, [productCode]: false }));

    setCart((prevCart) => ({ ...prevCart, [productCode]: newCount }));
    setBasketTotal((prevTotal) => prevTotal + 1);

    try {
      await putInBasket(newCount, productCode);
    } catch (e) {
      setErrorProducts((prev) => ({ ...prev, [productCode]: true }));
    } finally {
      setLoadingProducts((prev) => ({ ...prev, [productCode]: false }));
    }
  };

  const handleRemoveFromCart = async (productCode) => {
    const currentCount = cart[productCode] || 0;
    const newCount = currentCount - 1;

    setLoadingProducts((prev) => ({ ...prev, [productCode]: true }));
    setErrorProducts((prev) => ({ ...prev, [productCode]: false }));

    if (newCount <= 0) {
      setCart((prevCart) => {
        const { [productCode]: _, ...rest } = prevCart;
        return rest;
      });
      setBasketTotal((prevTotal) => prevTotal - 1);

      try {
        await putInBasket(0, productCode);
      } catch (e) {
        setErrorProducts((prev) => ({ ...prev, [productCode]: true }));
      } finally {
        setLoadingProducts((prev) => ({ ...prev, [productCode]: false }));
      }
    } else {
      setCart((prevCart) => ({ ...prevCart, [productCode]: newCount }));
      setBasketTotal((prevTotal) => prevTotal - 1);

      try {
        await putInBasket(newCount, productCode);
      } catch (e) {
        setErrorProducts((prev) => ({ ...prev, [productCode]: true }));
      } finally {
        setLoadingProducts((prev) => ({ ...prev, [productCode]: false }));
      }
    }
  };

  return {
    cart,
    basketTotal,
    basketSum,
    basketPvSum,
    productPrices,
    productPvs,
    setProductPrices,
    setProductPvs,
    handleAddToCart,
    handleRemoveFromCart,
    loadingProducts,
    errorProducts,
  };
};

export default useRecsBasket;